import React, {Component} from 'react';
import Breadcrumb from "../../common/breadcrumb";
import NotSignedInPitch from "./notSignedInPitch"

export class TournamentPageTemplate extends Component {

    componentDidUpdate(prevProps) {

    }

    renderSection() {
        const { user, title2, title3 } = this.props;

        return (
        <section className="blog-detail-page section-b-space" style={{paddingBottom: "2px"}}>
            <div className="container">
                <div className="row">
                    <div className="col-sm-12 blog-detail">                            
                        {title2 && 
                        <div className="row">
                            <div className="col-sm-12" >
                                <h4><span style={{padding: "4px"}}>{title2}</span></h4>
                            </div>
                        </div>
                        }
                        {title3 && user.isLoggedIn &&
                        <><br />                                   
                        <div className="row">
                            <div className="col-sm-12">
                                <h5 style={{marginBottom: "0px", paddingBottom: "2px"}}>
                                    {title3}
                                </h5>
                            </div>
                        </div></>
                        }
                    </div>
                </div>
            </div>
        </section>
        )
    }

    render () {
        const { user, title2, title3, bcTitle, bcParents, pid } = this.props;

        return (
            <div>
                <Breadcrumb title={bcTitle} parents={bcParents} />
                
                <div className="container-fluid">
                    <div className="row">
                        <div className="col-sm-12 blog-detail">                            
                            {title2 && 
                            <div className="row">
                                <div className="col-sm-12" >
                                    <h4><span style={{padding: "4px"}}>{title2}</span></h4>
                                </div>
                            </div>
                            }
                            {title3 && user.isLoggedIn &&
                            <><br />                                   
                            <div className="row">
                                <div className="col-sm-12">
                                    <h5 style={{marginBottom: "0px", paddingBottom: "2px"}}>
                                        {title3}
                                    </h5>
                                </div>
                            </div></>
                            }
                        </div>
                    </div>
                </div>
        
                {this.props.children}

                {!user.isLoggedIn &&
                <div className="row">
                    <div className="col-sm-12">
                        <NotSignedInPitch pid={pid} />
                    </div>
                </div>
                }                
            </div>
        )
    }
}

export default TournamentPageTemplate;